import { makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface IAccessGroup {
  [key: string]: any
}

export class AccessGroup extends Model<IAccessGroup> {
  static RelationTypes = {
    self: 'self',
    admins: 'admins',
    basics: 'basics',
    manager: 'manager',
    managers: 'managers',
    everyone: 'everyone',
    teamLead: 'team_lead',
    employeesTeamLead: 'employees_team_lead',
    timeoff_manager: 'timeoff_manager',
    notifiable: 'notifiable',
  }

  static NotifiableTypes = {
    team: 'Team',
    access: 'Access',
    location: 'Location',
    permissionGroup: 'Permissions::Group',
  }

  constructor(attr: IAccessGroup = {}) {
    super(attr)
    makeObservable(this, {})
  }

  static urlRoot() {
    return '/automations/access_groups'
  }
}
